import { ArrowLeftIcon, CalendarCheckIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { selectActiveBuilding } from '../../../reducers/buildingSelectorReducer'
import { formatDateRange } from '../utils'

interface PageHeaderProps {
  eventName: string
  eventStartTime: number
  eventEndTime: number
}

const PageHeader = ({ eventName, eventStartTime, eventEndTime }: PageHeaderProps) => {
  const { t } = useTranslation(['attendees', 'common'])
  const navigate = useNavigate()
  const selectedBuilding = useSelector(selectActiveBuilding)
  const selectedBuildingTimezone = selectedBuilding?.timezone

  return (
    <div className="attendees_page-header">
      <button className="button button-transparent" onClick={() => navigate('/dashboard/calendar')}>
        <ArrowLeftIcon size={20} />
        {t('common:actions.back')}
      </button>
      <h1 className="event-name">{eventName}</h1>
      <div className="event-date">
        <CalendarCheckIcon size={32} />
        <span>{t('attendees:pageHeader.startEnd')}</span>
        <span>{formatDateRange(eventStartTime, eventEndTime, selectedBuildingTimezone)}</span>
      </div>
    </div>
  )
}

export default PageHeader
